module.exports = __webpack_public_path__ + "media/src/images/top_covers/2021_jan_03-1308097f427240a255a51de7ac7dbced.png";